import { selectorFamily, SerializableParam, useRecoilValue } from 'recoil';
import { convertPaymentSummaries, dateRangeToDays } from 'functions';
import { PaymentService } from 'services';
import { currentDate, isAuthenticated, refreshState, useSetRefreshState } from 'state';
import { PaymentSummary } from 'types';
import { DateRangeType } from 'enums';

type PaymentSummaryParams = {
    accountId: string,
    dateRange: DateRangeType,
} & SerializableParam;

export const paymentSummaries = selectorFamily<PaymentSummary[], PaymentSummaryParams>({
    key: 'paymentSummaries',
    get: ({ accountId, dateRange }) =>
        async ({ get }) => {
            get(currentDate);
            get(refreshState(paymentSummaries({ accountId, dateRange }).key))
            if (get(isAuthenticated) && accountId) {
                const service = new PaymentService();
                const data = await service.getPaymentSummaries(accountId, dateRangeToDays(dateRange).toString());
                return convertPaymentSummaries(data);
            }
            return [];
        }
});

export const usePaymentSummaries = (accountId: string, dateRange: DateRangeType = DateRangeType.OneYear) =>
    useRecoilValue(paymentSummaries({ accountId, dateRange }));

export const useRefreshPaymentSummaries = (accountId: string, dateRange: DateRangeType = DateRangeType.OneYear) =>
    useSetRefreshState(paymentSummaries({ accountId, dateRange }));
